import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hashtag-container" }
const _hoisted_2 = { class: "tag-name" }
const _hoisted_3 = { class: "button-link__hashtag" }
const _hoisted_4 = {
  key: 1,
  class: "button-link__hashtag"
}
const _hoisted_5 = { class: "button-link__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_app_tooltip = _resolveComponent("app-tooltip")!
  const _component_app_tag_selector = _resolveComponent("app-tag-selector")!
  const _component_app_resizable_dropdown = _resolveComponent("app-resizable-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["button-link", { 'hashtag-text-type': _ctx.type === 'text' }]),
      onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseEnter && _ctx.handleMouseEnter(...args))),
      onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args))),
      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
    }, [
      (_ctx.type === 'text')
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item.Id,
              class: "tag-item",
              style: {"margin-left":"2px"}
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "button-link__hashtag" }, " # ", -1)),
              _createElementVNode("span", _hoisted_2, _toDisplayString(item.Name), 1)
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.selectorEnabled && !_ctx.disabled)
              ? (_openBlock(), _createBlock(_component_app_resizable_dropdown, {
                  key: 0,
                  ref: "dropdownRef",
                  class: "button-link__dropdown",
                  position: _ctx.dropdownPosition,
                  "close-by-click-outside": true,
                  "max-width": _ctx.dropdownMaxWidth,
                  "max-height": _ctx.dropdownMaxHeight
                }, {
                  activator: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, [
                      (!_ctx.disabled)
                        ? (_openBlock(), _createBlock(_component_app_tooltip, {
                            key: 0,
                            text: _ctx.tooltipText
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(_component_app_icon, {
                                name: "hash",
                                width: "16px",
                                color: "#979797",
                                "hover-color": "#499259",
                                cursor: "pointer"
                              })
                            ]),
                            _: 1
                          }, 8, ["text"]))
                        : (_openBlock(), _createBlock(_component_app_tooltip, {
                            key: 1,
                            text: _ctx.tooltipText
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(_component_app_icon, {
                                name: "hash",
                                width: "16px",
                                color: "#D2D2D2",
                                cursor: "pointer"
                              })
                            ]),
                            _: 1
                          }, 8, ["text"]))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_app_tag_selector, {
                      modelValue: _ctx.localSelectorValue,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSelectorValue) = $event)),
                        _ctx.handleSelectorChange
                      ],
                      "entity-type": _ctx.entityType,
                      mode: _ctx.tagSelectorMode,
                      "allow-create": _ctx.allowCreate,
                      "allow-select-group": _ctx.allowSelectGroup,
                      onCreateTag: _ctx.handleCreateTag,
                      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dropdownRef?.close()))
                    }, null, 8, ["modelValue", "entity-type", "mode", "allow-create", "allow-select-group", "onUpdate:modelValue", "onCreateTag"])
                  ]),
                  _: 1
                }, 8, ["position", "max-width", "max-height"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (!_ctx.disabled)
                    ? (_openBlock(), _createBlock(_component_app_tooltip, {
                        key: 0,
                        text: _ctx.tooltipText
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(_component_app_icon, {
                            name: "hash",
                            width: "16px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer"
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : (_openBlock(), _createBlock(_component_app_tooltip, {
                        key: 1,
                        text: _ctx.tooltipText
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(_component_app_icon, {
                            name: "hash",
                            width: "16px",
                            color: "#D2D2D2",
                            cursor: "pointer"
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                ])),
            _createElementVNode("span", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: item.Id,
                  class: "tag-item"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["tag-name", { 'tag-name-disabled': _ctx.disabled }])
                  }, _toDisplayString(item.Name.toLowerCase()), 3),
                  (_ctx.showClear)
                    ? (_openBlock(), _createBlock(_component_app_tooltip, {
                        key: 0,
                        text: `Удалить ${item.Name.toLowerCase()}`
                      }, {
                        activator: _withCtx(() => [
                          (!_ctx.disabled)
                            ? (_openBlock(), _createBlock(_component_app_icon, {
                                key: 0,
                                class: _normalizeClass({ 'button-link__cross-disabled': _ctx.disabled }),
                                name: "close-bold",
                                width: "12px",
                                color: "#D2D2D2",
                                "hover-color": "#499259",
                                cursor: "pointer",
                                onClick: _withModifiers(($event: any) => (_ctx.removeTag(item, index)), ["stop"])
                              }, null, 8, ["class", "onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["text"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ], 64))
    ], 34)
  ]))
}